<div class="container-fluid exection-body rounded card shadow h-100">
    <app-tab class="execution-tabs" [tabs]="tabs"></app-tab>
</div>
